import { Phone, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { BRAND, waLink } from "@/data/site";

export const FloatingCTA = () => (
  <>
    {/* Mobile bottom bar */}
    <div
      data-testid="floating-bar-mobile"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-bronze/15 bg-sand/90 backdrop-blur-xl"
    >
      <a
        href={BRAND.tel}
        data-testid="floating-call-mobile"
        className="flex items-center justify-center gap-2 py-4 text-xs uppercase tracking-[0.18em] text-bronze active:bg-bronze/10"
      >
        <Phone size={16} /> Call Now
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-mobile"
        className="flex items-center justify-center gap-2 py-4 text-xs uppercase tracking-[0.18em] text-white bg-wa"
      >
        <MessageCircle size={16} /> WhatsApp
      </a>
    </div>
    {/* Desktop corner stack */}
    <motion.div
      data-testid="floating-bar-desktop"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.6 }}
      className="hidden md:flex fixed bottom-8 right-8 z-40 flex-col gap-3"
    >
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-desktop"
        aria-label="Chat on WhatsApp"
        className="group flex items-center gap-0 rounded-full bg-wa text-white shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-shadow duration-300 hover:shadow-[0_14px_40px_rgba(37,211,102,0.5)]"
      >
        <span className="max-w-0 overflow-hidden group-hover:max-w-[140px] transition-[max-width,padding] duration-500 whitespace-nowrap text-xs uppercase tracking-[0.15em] group-hover:pl-5">
          WhatsApp Us
        </span>
        <span className="p-4">
          <MessageCircle size={20} />
        </span>
      </a>
      <a
        href={BRAND.tel}
        data-testid="floating-call-desktop"
        aria-label="Call Ody Luxurious Spa"
        className="group flex items-center gap-0 rounded-full bg-bronze text-cream shadow-[0_10px_30px_rgba(140,90,60,0.35)] transition-shadow duration-300 hover:shadow-[0_14px_40px_rgba(140,90,60,0.5)]"
      >
        <span className="max-w-0 overflow-hidden group-hover:max-w-[140px] transition-[max-width,padding] duration-500 whitespace-nowrap text-xs uppercase tracking-[0.15em] group-hover:pl-5">
          {BRAND.phoneDisplay}
        </span>
        <span className="p-4">
          <Phone size={20} />
        </span>
      </a>
    </motion.div>
  </>
);
